const entities = {
  title: "Entités",
  fullName: "Nom complet",
  pseudo: "Pseudo",
  mail: "Email",
  createdAt: "Créé le",
  type: "Type d'entité",
};

export default entities;
